import firebase from 'firebase/app'

export const connection = () => firebase.apps[0] || firebase.initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG))
